import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from "@mui/material";
import LoginHistory from "../../features/manageUsers/loginHistory";
import TransactionHistory from "../../features/manageUsers/transctionHistory";
import ReferralHistory from "../../features/manageUsers/refferalHistory";
import SearchBar from "../../components/SearchBar";
import UserAuditLogTable from "../../features/manageUsers/userAuditLogTable";
import AdjustedPointsTable from "../../features/manageUsers/adjustedPointsTable";
import PromotionFeedbackTable from "../../features/manageFeedbackReports/feedbackTable";
import { useGetCustomerDetailQuery } from "../../store/api/userAPI";
import { useGetOrdersQuery } from "../../store/api/orderAPI";
import Pagination from "../../components/Panigation";
import { ORDER_STATUS, PAYMENT_MODE } from "../../constants/enums";
import Loader from "../../constants/Loader";
import { showError } from "../../constants/toasts";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageUserDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get user ID from location state or use a default
  const userId = (location.state as any)?.user?.id || (location.state as any)?.user?._id;

  // Fetch user details
  const { data, isLoading, error } = useGetCustomerDetailQuery(
    { id: userId },
    { skip: !userId }
  );

  const userData = data?.data;

  // Show error if API call fails
  useEffect(() => {
    if (error) {
      const errorMessage = (error as any)?.data?.message || "Failed to fetch user details. Please try again.";
      showError(errorMessage);
    }
  }, [error]);

  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = useState(0);
  const [valueTabs1, setValueTabs1] = useState(0);
  const [valueTabs2, setValueTabs2] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs2(newValue);
  };

  const [status, setStatus] = useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };

  // Order History Logic
  const [orderPage, setOrderPage] = useState(1);
  const [orderStatusFilter, setOrderStatusFilter] = useState("default");

  const { data: ordersResponse, isLoading: isOrdersLoading } = useGetOrdersQuery({
    page: orderPage,
    limit: 10,
    userId: userId || "",
    status: orderStatusFilter !== "default" ? parseInt(orderStatusFilter) : undefined
  }, { skip: !userId });

  const orders = ordersResponse?.data?.order || [];
  const orderTotal = ordersResponse?.data?.totalCount || 0;
  const orderTotalPages = Math.ceil(orderTotal / 10);

  const getStatusString = (status: number) => {
    switch (status) {
      case ORDER_STATUS.PENDING: return "Pending";
      case ORDER_STATUS.ACCEPTED: return "Accepted";
      case ORDER_STATUS.PREPARING: return "Preparing";
      case ORDER_STATUS.READY_FOR_PICK_UP: return "Ready for Pickup";
      case ORDER_STATUS.PICKED_UP: return "Picked Up";
      case ORDER_STATUS.ON_THE_WAY: return "Out for Delivery";
      case ORDER_STATUS.DELIVERED: return "Delivered";
      case ORDER_STATUS.CANCELLED_BY_USER: return "Cancelled by User";
      case ORDER_STATUS.CANCELLED_BY_STORE: return "Cancelled by Store";
      default: return "Unknown";
    }
  };

  return (
    <>
      <div className="main_title">
        <h1>User Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>Manage Users</button>{" "}
          - User Detail
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              className="custom_tabs_links"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab label="Loyalty Points" {...a11yProps(1)} />
              <Tab label="Order History" {...a11yProps(2)} />
              <Tab label="Feedback & Rating" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Personal Info */}
      <CustomTabPanel value={valueTabs} index={0}>
        <Loader isLoad={isLoading} />
        <div className="cards view_page">
          <div className="table_header">
            <h2>Personal Info</h2>
          </div>
          {userData ? (
            <div className="gap_p">
              <div className="w_33">
                <h6>Full Name</h6>
                <p>{userData.fullName || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Email</h6>
                <p>
                  {userData.email || "N/A"}
                  {userData.isEmailVerified && (
                    <img src="/static/images/tick_icon.svg" alt="verified" style={{ marginLeft: "8px" }} />
                  )}
                </p>
              </div>
              <div className="w_33">
                <h6>Phone</h6>
                <p>
                  {userData.countryCode || ""} {userData.phone || "N/A"}
                  {userData.isPhoneVerified && (
                    <img src="/static/images/tick_icon.svg" alt="verified" style={{ marginLeft: "8px" }} />
                  )}
                </p>
              </div>
              <div className="w_33">
                <h6>Country</h6>
                <p>{userData.address?.country || "N/A"}</p>
              </div>
              <div className="w_33">
                <h6>Date Registered</h6>
                <p>
                  {userData.createdAt
                    ? new Date(userData.createdAt).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })
                    : "N/A"}
                </p>
              </div>
            </div>
          ) : (
            !isLoading && (
              <div style={{ padding: "20px", textAlign: "center" }}>
                <p>No user data available</p>
              </div>
            )
          )}
        </div>
      </CustomTabPanel>

      {/* Loyalty Points */}
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>
                  Total Loyalty Points - <span className="c_primary">1250</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="stats_boxes v2 gap_m">
            <div className="cards">
              <h2>500</h2>
              <p>Total Earned</p>
            </div>
            <div className="cards">
              <h2>100</h2>
              <p>Redeemed</p>
            </div>
            <div className="cards">
              <h2>20</h2>
              <p>Expired</p>
            </div>
            <div className="cards">
              <h2>200</h2>
              <p>In-Process</p>
            </div>
          </div>
        </div>

        <div className="cards mt_20">
          <Box className="custom_tabs">
            <Tabs
              value={valueTabs1}
              onChange={handleChangeTabs1}
              className="custom_tabs_links"
            >
              <Tab label="Transaction history" {...a11yProps(0)} />
              <Tab label="Referral points history" {...a11yProps(1)} />
              {/* <Tab label="Adjusted Points By Admin" {...a11yProps(2)} /> */}
            </Tabs>
          </Box>

          <CustomTabPanel value={valueTabs1} index={0}>
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
                <div className="form">
                  <Select
                    fullWidth
                    value={status}
                    onChange={handleStatusChange}
                  >
                    <MenuItem disabled value="default">
                      Select Type
                    </MenuItem>
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Redeemed">Redeemed</MenuItem>
                    <MenuItem value="Earned">Earned</MenuItem>
                    <MenuItem value="Expired">Expired</MenuItem>
                  </Select>
                </div>
              </div>
            </div>
            <TransactionHistory hideUserColumn />
          </CustomTabPanel>

          <CustomTabPanel value={valueTabs1} index={1}>
            <div className="table_header">
              <div className="left_s">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search..."
                />
              </div>
            </div>
            <ReferralHistory />
          </CustomTabPanel>

          {/* <CustomTabPanel value={valueTabs1} index={2}>
            <AdjustedPointsTable />
          </CustomTabPanel> */}
        </div>
      </CustomTabPanel>

      {/* Order History */}
      <CustomTabPanel value={valueTabs} index={2}>
        <div className="cards">
          <div className="table_header">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search orders..."
              />
            </Box>
            <div className="form">
              {/* Optional: Add status filter here if needed */}
            </div>
          </div>

          <Loader isLoad={isOrdersLoading} />

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Order ID</TableCell>
                  <TableCell>Total Items</TableCell>
                  <TableCell>Grand Total</TableCell>
                  <TableCell>Payment Mode</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {orders.length === 0 && !isOrdersLoading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">No orders found</TableCell>
                  </TableRow>
                ) : (
                  orders.map((order: any, index: number) => (
                    <TableRow hover key={order._id || index}>
                      <TableCell>{order.orderId || order._id}</TableCell>
                      <TableCell>{order.suborders?.length || 0}</TableCell>
                      <TableCell>{order.grandTotal ? `$${order.grandTotal}` : "N/A"}</TableCell>
                      <TableCell>
                        {order.paymentMode === 1 ? "Cash" : "Online"}
                        {order.paymentMode !== 1 && (order.paymentStatus === 1 ? " (Pending)" : order.paymentStatus === 3 ? " (Completed)" : "")}
                      </TableCell>
                      <TableCell>
                        <span className={`status_btn ${order.status === ORDER_STATUS.DELIVERED ? "success" : "warning"}`}>
                          {getStatusString(order.status)}
                        </span>
                      </TableCell>
                      <TableCell>
                        {order.createdAt
                          ? new Date(order.createdAt).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                          : "N/A"}
                      </TableCell>
                      <TableCell>
                        <Box display="flex">
                          <IconButton onClick={() => navigate("/manage-order/view")}>
                            <img
                              src="/static/images/eye_icon.svg"
                              alt="View"
                            />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {orderTotalPages > 0 && (
            <div className="table_footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', borderTop: '1px solid #e0e0e0' }}>
              <p style={{ margin: 0, color: '#717171', fontSize: '14px' }}>
                Showing <strong>{(orderPage - 1) * 10 + 1}</strong> to <strong>{Math.min(orderPage * 10, orderTotal)}</strong> of <strong>{orderTotal}</strong> entries
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Pagination
                  module={orders}
                  page={orderPage}
                  onPageChange={setOrderPage}
                  totalPages={orderTotalPages}
                  setPage={setOrderPage}
                  totalCount={orderTotal}
                  limit={10}
                />
              </div>
            </div>
          )}
        </div>
      </CustomTabPanel>

      <CustomTabPanel value={valueTabs} index={3}>
        <div className="cards">
          <PromotionFeedbackTable showUserColumn={false} userId={userId} />
        </div>
      </CustomTabPanel>
    </>
  );
};

export default ManageUserDetail;
